export default {
  methods: {
    setSwapTitle (key) {
      const self = this
      self.$emit('changeParentTitle', this.$i18n.t(key))
    }
  }
}
